import { PlatformSettings } from "../../../settings/platformSettings";
import { IApps } from "../interfaces/apps";
import { IAuthClient } from "../interfaces/authClient";
import { IReports } from "../interfaces/reports";
import { IRoles } from "../interfaces/roles";
import { IScopes } from "../interfaces/scopes";
import { ITokens } from "../interfaces/tokens";
import { IUsers } from "../interfaces/users";
import Apps from "./apps";
import Reports from "./reports";
import Roles from "./roles";
import Scopes from "./scopes";
import Tokens from "./tokens";
import Users from "./users";

export default class AuthClient implements IAuthClient {
  users: IUsers;
  apps: IApps;
  tokens: ITokens;
  scopes: IScopes;
  roles: IRoles;
  reports: IReports;
  constructor(private platformSettings: PlatformSettings) {
    this.users = new Users(platformSettings);
    this.apps = new Apps(platformSettings);
    this.tokens = new Tokens(platformSettings);
    this.scopes = new Scopes(platformSettings);
    this.roles = new Roles(platformSettings);
    this.reports = new Reports(platformSettings);
  }
}

export { AuthClient };
